export default {
    methods: {
        toUSD (value) {
            // console.log('toUSD = ' + value);
            if (value === undefined){
                return '';
            }

            let val = (value/1).toFixed(2).replace(',', '.')
            return `$` + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        twoDecimals (value) {
            // console.log('toUSD = ' + value);
            if (value === undefined){
                return '';
            }

            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    }
  };
  